export class ServiceMapping {
	ServiceAndProductMappingId: number;
	SourceServiceDescription: string;
	SourceServiceCategory: string;
	SourceServiceSubcategory: string;
	MappingModeName: string;
	ServiceTypeName: string;
	SegmentName: string;
	SubSegmentName: string;
	CreatedOn: Date;
	ModifiedByUserFullNameSortable: string;
	ReviewedByUserFullNameSortable: string;
}

export class ServiceMappingGridReturnModel {
	data: ServiceMappingGridModel[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export class ServiceMappingGridModel {
		Active: boolean;
		CreatedByUserFullNameSortableOrPrincipalName: string;
		CreatedByUserId: number;
		CreatedByUserRoleId: number;
		CreatedOn: Date;
		Definition: string;
		MappingAssignedToUserFullNameSortableOrPrincipalName: string;
		MappingAssignedToUserId: number;
		MappingAssignedToUserRoleId: number;
		MappingModeId: number;
		MappingModeKey: string;
		MappingModeName: string;
		MappingPriority: number;
		ModifiedByUserFullNameSortableOrPrincipalName: string;
		ModifiedByUserId: number;
		ModifiedByUserRoleId: number;
		ModifiedOn: Date;
		RelatedTerms: string;
		ReviewedByUserFullNameSortableOrPrincipalName: string;
		ReviewedByUserId: number;
		ReviewedByUserRoleId: number;
		ReviewedOn: Date;
		SegmentId: number;
		SegmentName: string;
		ServiceAndProductMappingId: number;
		ServiceMasterId: number;
		ServiceTypeId: number;
		ServiceTypeName: string;
		SourceBrand: string;
		SourceCategory: string;
		SourceCompany: string;
		SourceDescription: string;
		SourceMasterBrand: string;
		SourceSubBrand: string;
		SourceSubcategory: string;
		SubSegmentId: number;
		SubSegmentName: string;
}

export class ServiceMappingToMasterGridResult {
	MappingAsService: boolean;
	ServiceMasterIsActive: boolean;
	CurrentMappingModeId: number;
	CurrentServiceMasterId: number;
	MappingModeId: number;
	Ranking: number;
	SegmentId: number;
	ServiceAndProductMappingId: number;
	ServiceMasterId: number;
	ServiceTypeId: number;
	SubSegmentId: number;
	Definition: string;
	MappingModeName: string;
	MappingSource: string;
	RelatedTerms: string;
	SegmentName: string;
	ServiceTypeName: string;
	SubSegmentName: string;
}

export class ServiceMasterExpandedReturnModel {
	data: ServiceMasterExpandedModel[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export class ServiceMasterExpandedModel {
	Active: boolean;
	SegmentIsActive: boolean;
	SegmentRelationIsActive: boolean;
	ServiceMasterIsActive: boolean;
	ServiceTypeIsActive: boolean;
	SubSegmentIsActive: boolean;
	CreatedOn: Date;
	ModifiedOn: Date;
	ReviewedOn: Date;
	CreatedByUserId: number;
	CreatedByUserRoleId: number;
	ModifiedByUserId: number;
	ModifiedByUserRoleId: number;
	ReviewedByUserId: number;
	ReviewedByUserRoleId: number;
	SegmentId: number;
	SegmentRelationId: number;
	ServiceMasterId: number;
	ServiceTypeId: number;
	SubSegmentId: number;
	CreatedByUserEmailAddress: string;
	CreatedByUserFullName: string;
	CreatedByUserFullNameOrPrincipalName: string;
	CreatedByUserFullNameSortable: string;
	CreatedByUserFullNameSortableOrPrincipalName: string;
	CreatedByUserGivenName: string;
	CreatedByUserGivenNameAndSurname: string;
	CreatedByUserGivenNameAndSurnameOrPrincipalName: string;
	CreatedByUserMiddleName: string;
	CreatedByUserPrincipalName: string;
	CreatedByUserRoleKey: string;
	CreatedByUserRoleName: string;
	CreatedByUserSurname: string;
	Definition: string;
	ModifiedByUserEmailAddress: string;
	ModifiedByUserFullName: string;
	ModifiedByUserFullNameOrPrincipalName: string;
	ModifiedByUserFullNameSortable: string;
	ModifiedByUserFullNameSortableOrPrincipalName: string;
	ModifiedByUserGivenName: string;
	ModifiedByUserGivenNameAndSurname: string;
	ModifiedByUserGivenNameAndSurnameOrPrincipalName: string;
	ModifiedByUserMiddleName: string;
	ModifiedByUserPrincipalName: string;
	ModifiedByUserRoleKey: string;
	ModifiedByUserRoleName: string;
	ModifiedByUserSurname: string;
	RelatedTerms: string;
	ReviewedByUserEmailAddress: string;
	ReviewedByUserFullName: string;
	ReviewedByUserFullNameOrPrincipalName: string;
	ReviewedByUserFullNameSortable: string;
	ReviewedByUserFullNameSortableOrPrincipalName: string;
	ReviewedByUserGivenName: string;
	ReviewedByUserGivenNameAndSurname: string;
	ReviewedByUserGivenNameAndSurnameOrPrincipalName: string;
	ReviewedByUserMiddleName: string;
	ReviewedByUserPrincipalName: string;
	ReviewedByUserRoleKey: string;
	ReviewedByUserRoleName: string;
	ReviewedByUserSurname: string;
	SegmentName: string;
	ServiceTypeName: string;
	SubSegmentName: string;
}
